import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";
import IResourceArray = ng.resource.IResourceArray;

const debug: Debugger = require('debug')('PlanRessurs');

export class PlanRessurs extends BasisRessurs<l.PlanModell> {
    static regNavn = "planRessurs";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            PlanRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super("plan", $resource, ressursFeilhåndtering, gettextCatalog, {
            'hentEnkel': {method: 'GET', url: "/api/plan/:id/enkel"},
            'hentAlle': {method: 'GET', url: "/api/plan/hentAlle/:gruppeId", params: {gruppeId: "@gruppeId"}, isArray: true},
            'hentAlleForGrupper': {method: 'GET', url: "/api/plan/hentAlleForGrupper", isArray: true},
            'hentPlanerFraOgMedNaa': {method: 'GET', url: "/api/plan/hentPlanerFraOgMedNaa/:gruppeId", params: {gruppeId: "@gruppeId"}, isArray: true},
            'hentPlanerFraOgMed': {method: 'GET', url: "/api/plan/hentPlanerFraOgMed/:gruppeId", params: {gruppeId: "@gruppeId"}, isArray: true},
            'opprettPlanMedMøter': {method: 'PUT', url: "/api/plan/:gruppeId/medmoeter", params: {gruppeId: "@gruppeId"}},
            'settFoersteNummer': {method: 'POST', url: "/api/plan/:planId/settFoersteNummer", params: {planId: "@planId"}}
        });
    }

    hentEnkel(planId: string): l.EnkelPlanModell {
        debug('hentEnkel', planId)
        return this.ressurs['hentEnkel'](
            {id: planId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste liste over planer")));
    }

    hentAlle(gruppeId: string, vedOk: (planer: l.PlanModell[]) => void = _.noop): IResourceArray<l.PlanModell> {
        debug('hentAlle', gruppeId)
        return this.ressurs['hentAlle'](
            {gruppeId: gruppeId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste liste over planer")));
    }

    hentAlleForGrupper(gruppeIder: string[]): IResourceArray<l.EnkelPlanModell> {
        debug('hentAlleForGrupper', gruppeIder)
        return this.ressurs['hentAlleForGrupper'](
            {gruppeIder: gruppeIder},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste liste over planer")));
    }

    hentPlanerFraOgMedNaa(gruppeId: string, vedOk: (planer: l.PlanModell[]) => void = _.noop): IResourceArray<l.PlanModell> {
        debug('hentPlanerFraOgMedNaa', gruppeId)
        return this.ressurs['hentPlanerFraOgMedNaa'](
            {gruppeId: gruppeId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste liste over planer")));
    }

    hentPlanerFraOgMed(gruppeId: string, start: Date, vedOk: (planer: l.PlanModell[]) => void = _.noop): IResourceArray<l.PlanModell> {
        debug('hentPlanerFraOgMed', gruppeId, start)
        return this.ressurs['hentPlanerFraOgMed'](
            {gruppeId: gruppeId, start: start},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste liste over planer")));
    }

    opprettPlanMedMøter(gruppeId: string, spesifikasjon: l.PlanMedMøterSpesifikasjon): l.OkRespons {
        debug('opprettPlanMedMøter', gruppeId, spesifikasjon)
        return this.ressurs['opprettPlanMedMøter'](
            _.assign({gruppeId: gruppeId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette plan")));
    }

    settFoersteNummer(planId: string, forsteMotenummer: number, forsteSaksnummer: number): l.PlanModell {
        debug('settFoersteNummer', planId)
        return this.ressurs['settFoersteNummer'](
          _.assign({planId: planId}, {førsteMøtenummer: forsteMotenummer, førsteSaksnummer: forsteSaksnummer}),
          _.noop,
          this.håndterFeil(() => this.gettextCatalog.getString("Kunne ikke oppdatere møtenummer")));
    }

}
